module.exports = __webpack_public_path__ + "img/popfm_pic5.1562e2c4.png";